export const BOT_AVATAR = 'robot.png';
